import { rankAutoplayCandidates } from '../lib/autoplayEngine';

const API = process.env.REACT_APP_BACKEND_URL;
const ANALYTICS_KEY = 'rastyle_autoplay_analytics_v1';

const asList = (payload, keys = []) => {
  if (Array.isArray(payload)) return payload;
  for (const key of keys) {
    if (Array.isArray(payload?.[key])) return payload[key];
  }
  return [];
};

const normalizeMixtape = (item = {}) => ({
  ...item,
  track_id: String(item.id || item.track_id || ''),
  track_type: 'mixtape',
  title: item.title || item.name || '',
  artist: item.dj || item.dj_name || item.artist || 'Rastyle Selector',
  cover: item.cover || item.cover_image || item.artwork_url || '',
  duration: Number(item.duration) || 0,
  hearthis_url: item.hearthis_url || '',
  stream_url: item.stream_url || item.audio_url || '',
  genre: item.genre || item.category || '',
  mood: item.mood || '',
  era: item.era || '',
  tags: item.tags || item.categories || [],
  popularity: item.play_count || item.plays || item.views || 0,
});

const normalizeVideo = (item = {}) => ({
  ...item,
  track_id: String(item.id || item.video_id || item.youtube_id || ''),
  track_type: 'youtube',
  title: item.title || item.name || '',
  artist: item.channel_title || item.dj || item.artist || 'Rastyle TV',
  cover: item.thumbnail || item.thumbnail_url || item.cover_image || '',
  duration: Number(item.duration) || 0,
  youtube_id: item.youtube_id || item.video_id || '',
  url: item.url || '',
  genre: item.genre || item.category || '',
  mood: item.mood || '',
  era: item.era || '',
  tags: item.tags || item.categories || [],
  popularity: item.view_count || item.views || 0,
});

const fetchJson = async (url) => {
  const response = await fetch(url, { credentials: 'include' });
  if (!response.ok) throw new Error(`Recommendation catalogue request failed: ${response.status}`);
  return response.json();
};

const fetchRecommendationCatalogue = async () => {
  const results = await Promise.allSettled([
    fetchJson(`${API}/api/mixtapes?limit=100`),
    fetchJson(`${API}/api/videos?type=mix&limit=100`),
  ]);

  const mixtapes = results[0].status === 'fulfilled'
    ? asList(results[0].value, ['mixtapes', 'items']).map(normalizeMixtape)
    : [];
  const videos = results[1].status === 'fulfilled'
    ? asList(results[1].value, ['videos', 'items']).map(normalizeVideo)
    : [];

  return [...mixtapes, ...videos];
};

const getAutoplayRecommendations = async ({ seed, queue, history, limit = 5 }) => {
  const candidates = await fetchRecommendationCatalogue();
  return rankAutoplayCandidates({ seed, candidates, queue, history, limit });
};

const recordAutoplayEvent = (event, payload = {}) => {
  const entry = { event, ...payload, at: new Date().toISOString() };
  try {
    const previous = JSON.parse(localStorage.getItem(ANALYTICS_KEY) || '[]');
    localStorage.setItem(ANALYTICS_KEY, JSON.stringify([...previous, entry].slice(-250)));
  } catch {
    // Analytics must never interrupt playback.
  }
  try {
    window.dispatchEvent(new CustomEvent('rastyle:autoplay-analytics', { detail: entry }));
  } catch {
    // Browser event dispatch is best effort.
  }
  return entry;
};

export {
  ANALYTICS_KEY,
  fetchRecommendationCatalogue,
  getAutoplayRecommendations,
  normalizeMixtape,
  normalizeVideo,
  recordAutoplayEvent,
};
